import { useStaticQuery, graphql } from 'gatsby'
import { convertUrlToImageFileIdentifier } from './links'

type FileNode = {
  publicURL: string
  url: string | null
}

type FileEdge = {
  node: FileNode
}

type AllFileQuery = {
  allFile: {
    edges: FileEdge[]
  }
}

type StrapiImageMapper = {
  mapStrapiImageToGatsby: (strapiUrl: string) => string | undefined
}

export const useStrapiImageMapper = (): StrapiImageMapper => {
  const data = useStaticQuery<AllFileQuery>(graphql`
    query MapStrapiImages {
      allFile {
        edges {
          node {
            publicURL
            url
          }
        }
      }
    }
  `)

  const strapiToGatsbyMap = data.allFile.edges.reduce<Record<string, string>>((map, edge) => {
    if (edge.node.url) {
      const uploadedFileIdentifier = convertUrlToImageFileIdentifier(edge.node.url)
      map[uploadedFileIdentifier] = edge.node.publicURL
    }
    return map
  }, {})

  const mapStrapiImageToGatsby = (strapiImageFileIdentifier: string): string | undefined => {
    const gatsbyUrl = strapiToGatsbyMap[strapiImageFileIdentifier]
    if (!gatsbyUrl) {
      console.error(
        `Image "${strapiImageFileIdentifier}" not found in Gatsby static files. Make sure it has been downloaded from Strapi.`
      )
    }
    return gatsbyUrl
  }

  return {
    mapStrapiImageToGatsby,
  }
}
